module.exports = __webpack_public_path__ + "img/map-marker-icon.df17c5bb.svg";